<template>
    <b-modal size="xl" button-size="sm" hide-footer v-model="showModal" :title="prefix + title">
        <Pessoa-list :precisaExistirUsuario="precisaExistirUsuario" @onDblClickPessoa="pessoaSelect"
            :prefix="prefix  ">
        </Pessoa-list>
    </b-modal>
</template>
<script>

export default {
    components: { PessoaList: () => import("@/modules/cadastros/pessoa/PessoaList.vue") },

    props: {
        precisaExistirUsuario: {
            type: Boolean,
            default: false,
        },
        id: String,
        prefix: {
            type: String,
            default: "",
        }
    },

    mounted() {
    },

    computed: {
        url() {
            return `/api/pessoa`;
        },
    },

    data() {
        return {
            showModal: false,
            title: "Pessoa",
        }
    },

    methods: {
        async show() {
            this.showModal = true;
        },

        async pessoaSelect(item) {
            this.$emit("onSelect", item);
        },

        async close() {
            this.$emit("onClear");
        },
    }

};
</script>